import React, { useState } from 'react';

export default function SaveAsModal({ 
  isOpen, 
  onClose, 
  onSave, 
  currentPatternName = "",
  currentFolderName = "Uncategorized",
  savedPatterns = [],
  subscriptionTier = "free"
}) {
  const [newPatternName, setNewPatternName] = useState(currentPatternName);
  const [newFolderName, setNewFolderName] = useState(currentFolderName);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    const trimmedName = newPatternName.trim();
    const trimmedFolder = newFolderName.trim() || "Uncategorized";

    // Validation
    if (!trimmedName) {
      setError("Pattern name is required");
      return;
    }

    // Check if pattern already exists
    const exists = savedPatterns.some(
      p => p.name === trimmedName && p.folder === trimmedFolder
    );
    
    if (exists) {
      setError(`Pattern "${trimmedName}" already exists in "${trimmedFolder}"`);
      return;
    }

    // Check pattern limits
    let allowedCount;
    if (subscriptionTier === "pro") allowedCount = Infinity;
    else if (subscriptionTier === "basic") allowedCount = 10;
    else allowedCount = 3;

    if (savedPatterns.length >= allowedCount) {
      setError(`Pattern limit reached (${allowedCount}). Please upgrade or delete patterns.`);
      return;
    }

    setIsLoading(true);
    try {
      await onSave(trimmedName, trimmedFolder);
      onClose(); // Only close on success
    } catch (error) {
      setError("Failed to save pattern. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg p-6 w-96 max-w-md">
        <h2 className="text-xl font-bold mb-4">Save Pattern As...</h2>
        
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Pattern Name</label>
          <input
            type="text"
            value={newPatternName}
            onChange={(e) => {
              setNewPatternName(e.target.value);
              setError("");
            }}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter pattern name..."
            autoFocus
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Folder</label>
          <input
            type="text"
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Uncategorized"
          />
        </div>

        {error && (
          <div className="mb-4 text-red-600 text-sm">{error}</div>
        )}

        <div className="flex space-x-3">
          <button
            onClick={handleSave}
            disabled={isLoading}
            className={`flex-1 py-2 px-4 rounded text-white ${
              isLoading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-blue-500 hover:bg-blue-600'
            }`}
          >
            {isLoading ? 'Saving...' : 'Save As'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}